import { render, staticRenderFns } from "./EditRecipeDialog.vue?vue&type=template&id=2120bc97&scoped=true&"
import script from "./EditRecipeDialog.vue?vue&type=script&lang=js&"
export * from "./EditRecipeDialog.vue?vue&type=script&lang=js&"
import style0 from "./EditRecipeDialog.vue?vue&type=style&index=0&id=2120bc97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2120bc97",
  null
  
)

export default component.exports